import React from 'react';
import { useQuery } from 'react-query';
import { PropTypes } from 'prop-types';

import { url, getCarouselSlides } from '@general/api/carouselAPI';

const useCarousel = section =>
    useQuery([url, { section }], getCarouselSlides(section), {
        cacheTime: Infinity,
        staleTime: Infinity,
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        refetchOnReconnect: false,
    });

useCarousel.propTypes = {
    section: PropTypes.String,
};

export default useCarousel;
